import { gql } from '@apollo/client';
import BaseService from './baseService';

class ContactMethodsService extends BaseService {
  constructor() {
    super();
    this.contactMethodGql = `
      preferredContactMethodId
      method
    `;
    this.companyContactMethodGql = `
      preferredContactMethodId
      contactMethod
    `;
  }

  getContactMethods = () => new Promise((resolve, reject) => {
    const CONTACT_METHODS = gql`
      query {
        contactMethods{
            ${this.contactMethodGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: CONTACT_METHODS
      })
      .then((result) => {
        if (result.data.contactMethods) {
          resolve(result.data.contactMethods);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getClientContactMethods = () => new Promise((resolve, reject) => {
    const CONTACT_METHODS = gql`
      query {
        companyContactMethods{
            ${this.companyContactMethodGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: CONTACT_METHODS
      })
      .then((result) => {
        if (result.data.companyContactMethods) {
          resolve(result.data.companyContactMethods);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const contactMethodsService = new ContactMethodsService();

export default contactMethodsService;
